/* HeroFullImage.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { xcss } from '@atlaskit/primitives';
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import React from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _11 = "@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
const _10 = "._tzy4idpf{opacity:0}";
const _9 = "._y44v17nv{animation:fadeIn .5s ease-in-out forwards}";
const _8 = "@media (min-width:48rem) and (max-width:63.99rem){._1gzv1jfw{gap:var(--ds-space-500,40px)}._1m491h6o{justify-content:center}._55br1bp4{flex-direction:column}._i6jx1jfw{padding-top:var(--ds-space-500,40px)}}";
const _7 = "@media not all and (min-width:48rem){._8164xy5q{gap:var(--ds-space-400,2pc)}._nssp1h6o{justify-content:center}._1gde1bp4{flex-direction:column}._1kmx1ejb{padding-top:var(--ds-space-300,24px)}}";
const _6 = "._1bsb1osq{width:100%}";
const _5 = "._1bah1yb4{justify-content:space-between}";
const _4 = "._2lx2vrvc{flex-direction:row}";
const _3 = "._1wpz1fhb{align-self:stretch}";
const _2 = "._4cvr1h6o{align-items:center}";
const _ = "._1e0c1txw{display:flex}";
const fadeInAnimation = null;
const HeroWrapperBodyStyle = null;
const HeroImageContainerStyle = xcss({
  width: '100%',
  height: 'auto',
  objectFit: 'contain'
});
const HeroImageDesktopStyle = null;
const HeroImageStyle = null;
export const HeroFullImage = _ref => {
  let {
    heroDesktopImage,
    heroTabletImage,
    heroMobileImage,
    redirectUrl,
    onBannerClick,
    onKeyDownBanner
  } = _ref;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8]
    }), /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      "data-testid": "hero-full-image"
    }, redirectUrl && {
      role: 'button',
      tabIndex: 0,
      onClick: e => onBannerClick(e, redirectUrl),
      onKeyDown: e => onKeyDownBanner(e, redirectUrl)
    }), {}, {
      className: ax(["_1e0c1txw _4cvr1h6o _1wpz1fhb _2lx2vrvc _1bah1yb4 _1bsb1osq _8164xy5q _nssp1h6o _1gde1bp4 _1kmx1ejb _1gzv1jfw _1m491h6o _55br1bp4 _i6jx1jfw"]),
      children: [/*#__PURE__*/_jsx(Hide, {
        below: "md",
        xcss: HeroImageContainerStyle,
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_9, _10, _6, _11]
          }), /*#__PURE__*/_jsx("img", {
            alt: "",
            src: heroDesktopImage,
            className: ax(["_y44v17nv _tzy4idpf _1bsb1osq", "_y44v17nv"])
          })]
        })
      }), /*#__PURE__*/_jsxs(Show, {
        xcss: HeroImageContainerStyle,
        below: "md",
        children: [/*#__PURE__*/_jsx(Hide, {
          below: "xs",
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_9, _6, _10, _11]
            }), /*#__PURE__*/_jsx("img", {
              alt: "",
              src: heroTabletImage,
              className: ax(["_y44v17nv _1bsb1osq _tzy4idpf", "_y44v17nv"])
            })]
          })
        }), /*#__PURE__*/_jsx(Show, {
          xcss: HeroImageContainerStyle,
          below: "xs",
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_9, _6, _10, _11]
            }), /*#__PURE__*/_jsx("img", {
              alt: "",
              src: heroMobileImage,
              className: ax(["_y44v17nv _1bsb1osq _tzy4idpf", "_y44v17nv"])
            })]
          })
        })]
      })]
    }))]
  });
};